export default __webpack_public_path__ + "static/media/template9.ca5ef83f.jpg";